(function() {
  "use strict";

  angular.module("app").directive("cccTypeahead", cccTypeahead);

  function cccTypeahead() {
    return {
      restrict: "EA",
      scope: false,
      controller: "TypeaheadController"
    };
  }
})();
